(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-add-to-cart-bar"] && !Shopify.designMode) return;
  try {
    // JavaScript is loaded via assets/sticky-add-to-cart-bar.js
  } catch(e) { console.error(e); }
})();

})();
